/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useRef, useState } from 'react';
import angleDown from '../assets/images/angle_up_down.svg';
import checkmarkSaved from '../assets/images/model/checkmark_saved.svg';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import close from '../assets/images/close-circle.svg';
import checkBox from '../assets/images/check_box.svg';
import 'react-h5-audio-player/lib/styles.css';
import './questionstypes.css';
import MediaComponent from './activity/MediaComponent';
const MultipleChoiceOpions = ({ isEditing, question, setQuestions, index, isMore }) => {
  const isS3Url = (url) => {
    return url.includes('s3.amazonaws.com');
  };

  const isYouTubeUrl = (url) => {
    return url.includes('youtube.com') || url.includes('youtu.be');
  };
  const audioRef = useRef();
  const [textareaHeights, setTextareaHeights] = useState([40]);

  /* Long option */
  const getTextLengthClass = (text) => {
    return text.length > 30 ? 'long_option' : 'short_option';
  };

  /*  */
  const handleInputChange = (e, questionIndex, optionIndex) => {
    const { value } = e.target;

    // Update textarea height if necessary
    const textarea = e.target;
    textarea.style.height = 'auto';
    const newHeight = textarea.scrollHeight;
    textarea.style.height = `${newHeight}px`;

    // setTextareaHeights((prevHeights) => {
    //   const newHeights = [...prevHeights];
    //   newHeights[questionIndex][optionIndex] = newHeight;
    //   return newHeights;
    // });

    // Update text value in questionss
    setQuestions((oldQuestions) =>
      oldQuestions.map((question, index) =>
        index === questionIndex
          ? {
              ...question,
              options: question.options.map((option, oi) =>
                oi === optionIndex ? { ...option, text: value } : option
              ),
            }
          : question
      )
    );
  };

  const getDragHandleHeight = (optionType, currentHeight) => {
    const defaultHeights = {
      text: 40,
      image: 148,
      video: 148,
      audio: 115,
    };
    const defaultHeight = defaultHeights[optionType] || 148;

    return defaultHeight + Math.max(currentHeight - 40, 0);
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const { source, destination } = result;

    setQuestions((oldQuestions) => {
      const copiedQuestions = [...oldQuestions];
      const sourceQuestion = copiedQuestions[source.droppableId];

      if (source.droppableId === destination.droppableId) {
        const reorderedOptions = Array.from(sourceQuestion.options);
        const [removed] = reorderedOptions.splice(source.index, 1);
        reorderedOptions.splice(destination.index, 0, removed);
        sourceQuestion.options = reorderedOptions;
      } else {
        return oldQuestions;
      }

      return copiedQuestions;
    });
  };

  /* Upload Media to Options */
  const handleMediaUpload = (imageFile, optionIndex, questionIndex) => {
    setQuestions((old) =>
      old.map((question, qIndex) => {
        return qIndex !== index
          ? question
          : {
              ...question,
              options: question.options.map((op, opIndex) =>
                opIndex === optionIndex ? { ...op, url: imageFile } : op
              ),
            };
      })
    );
  };

  /* ......................... */

  /* For Audio Source */
  const formatTime = (time) => {
    if (!time) return '0:00';
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div key={index}>
        {question.type === 'mcqs' && (
          <Droppable droppableId={index.toString()} type='OPTIONS'>
            {(provided) => (
              <div
                ref={provided.innerRef}
                {...provided.droppableProps}
                className={`${'save_state_mcqs'}`}
              >
                {question.options.map((option, optionIndex) => (
                  <Draggable
                    key={option.order}
                    draggableId={`${index}-${option.order}`}
                    index={optionIndex}
                    isDragDisabled={!isEditing}
                  >
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        className={`orderlist-item ${
                          !isEditing ? 'save_state_border ' : 'border_none'
                        } ${!isEditing && getTextLengthClass(option.text)}`}
                      >
                        {isEditing ? (
                          <>
                            <RenderEditOption
                              provided={provided}
                              option={option}
                              handleMediaUpload={handleMediaUpload}
                              questionIndex={index}
                              optionIndex={optionIndex}
                              textareaHeights={textareaHeights}
                              handleInputChange={handleInputChange}
                              getDragHandleHeight={getDragHandleHeight}
                              isS3Url={isS3Url}
                              isYouTubeUrl={isYouTubeUrl}
                              formatTime={formatTime}
                              audioRef={audioRef}
                              isEditing={isEditing}
                            />
                            <div className='check_cros_img'>
                              <div
                                style={{
                                  position: 'relative',
                                  right: '9px',
                                  width: '24px',
                                  height: '24px',
                                }}
                              >
                                <img
                                  className='cursor'
                                  src={close}
                                  alt='unselect'
                                  onClick={() => {
                                    setQuestions((old) =>
                                      old.map((q, qi) =>
                                        qi === index
                                          ? {
                                              ...q,
                                              options: q.options.filter(
                                                (o, oi) => oi !== optionIndex
                                              ),
                                            }
                                          : q
                                      )
                                    );
                                  }}
                                />
                              </div>

                              <img
                                className={`check_true cursor ${
                                  option.isCorrect ? 'correct-option' : ''
                                }`}
                                src={checkBox}
                                alt='select'
                                value={option.text}
                                onClick={() => {
                                  setQuestions((old) =>
                                    old.map((q, qi) =>
                                      qi === index
                                        ? {
                                            ...q,
                                            options: q.options.map((o, oi) =>
                                              oi === optionIndex
                                                ? {
                                                    ...o,
                                                    isCorrect: !o.isCorrect,
                                                  }
                                                : { ...o, isCorrect: false }
                                            ),
                                          }
                                        : q
                                    )
                                  );
                                }}
                              />
                            </div>
                          </>
                        ) : (
                          <>
                            <RenderSavedOption
                              provided={provided}
                              option={option}
                              questionIndex={index}
                              optionIndex={optionIndex}
                              textareaHeights={textareaHeights}
                              getDragHandleHeight={getDragHandleHeight}
                              isS3Url={isS3Url}
                              isYouTubeUrl={isYouTubeUrl}
                              formatTime={formatTime}
                              audioRef={audioRef}
                              isEditing={isEditing}
                            />
                            {option.isCorrect && (
                              <img
                                className='image_save_tick'
                                src={checkmarkSaved}
                                alt='check'
                                value={option.text}
                              />
                            )}
                          </>
                        )}
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        )}
      </div>
    </DragDropContext>
  );
};
const RenderEditOption = ({
  option,
  questionIndex,
  optionIndex,
  handleInputChange,
  handleMediaUpload,
  isEditing,
}) => {
  const renderMedia = ['image', 'video', 'audio'].includes(option.type);
  return (
    <>
      <div className='parent_input_with_image mcqs_border'>
        <div className='parent_input'>
          <div className='order-number'>
            <span className='order-number-box'>{String.fromCharCode(65 + optionIndex)}</span>
          </div>
          <textarea
            id={`textarea-${questionIndex}-${optionIndex}`}
            className='orderlist-input'
            placeholder={option.type === 'text' ? `Add text` : `Add text (optional)`}
            rows={1}
            value={option.text}
            onChange={(e) => handleInputChange(e, questionIndex, optionIndex)}
            style={{
              height: `40px`,
            }}
          />
          {/* <div className='dropdown-arrow'>
            <img src={angleDown} alt='down arrow' />
          </div> */}
        </div>
        {renderMedia && (
          <MediaComponent
            media={option}
            isEditing={isEditing}
            onSuccess={(fileUrl, alt, attribution) => {
              handleMediaUpload(fileUrl, optionIndex, questionIndex);
            }}
            level='option'
          />
        )}
      </div>
    </>
  );
};

const RenderSavedOption = ({ option, isEditing, optionIndex }) => {
  const renderMedia = ['image', 'video', 'audio'].includes(option.type);
  return (
    <>
      <div className='parent_input_with_image'>
        <div className='parent_input' style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div className='order-number order-number_save'>
              <span className='order-number-box order-number-box_save checkbox_border_color'>
                {option.order || String.fromCharCode(65 + optionIndex)}
              </span>
            </div>
            {option.text && (
              <div className='orderlist-input option_save_state option_saved_1'>{option.text}</div>
            )}
          </div>
          {renderMedia && <MediaComponent media={option} level='option' isEditing={isEditing} />}
        </div>
      </div>
    </>
  );
};

export default MultipleChoiceOpions;
